<div class="row px-3">
    <div *ngIf="!readonly" class="col">
        <determinant-list
            [groupsLength]="{value: jsonString}"
            [prefix]="'db'"
            (onAddModalOpened)="askForEdit.emit()"
            (onEditModalOpened)="askForEdit.emit()"
            [determinantMapById]="determinantMapById"
            [addDeterminantTo]="_appendDeterminant">
        </determinant-list>
    </div>
    <div class="{{readonly ? '' : 'col d-flex flex-column'}}">
        <ng-content></ng-content>
        <query-builder *ngIf="determinantMapById != null" [determinantMapById]="determinantMapById" [prefix]="'db'"
                       [jsonString]="jsonString" [jsonLogic]="jsonLogic"
                       [noneSelectedText]="noneSelectedText"
                       [readOnly]="readonly"
                       class="flex-grow-1"
                       (onChange)="formChanged($event)"></query-builder>
        <div class="row mt-3" *ngIf="showBehaviour">
            <div class="col">
                <div class="determinant-main-hint">
                    <label class="input-label mt-2">{{ 'Component behavior' | translate }}</label>
                    <select class="form-control" [(ngModel)]="determinantValue"
                          (change)="onDeterminantValueSave.emit(determinantValue);$event.stopPropagation()">
                        <option value="true" selected>{{ 'Show and activate' | translate }}</option>
                        <option value="false">{{ 'Hide and deactivate' | translate }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div *ngIf="showSaveCancelRow"
             style="display: flex;align-items: baseline;justify-content: flex-start">
            <primary-text-button [noLeftPadding]="true"
                                 *ngIf="jsonString"
                                 (click)="onSave.emit(jsonString)">
                {{'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button (click)="onCancel.emit()">
                {{'Cancel' | translate }}
            </cancelary-text-button>
        </div>
    </div>
</div>
